// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"1387381c","503":"e0a1fd6b"}[chunkId] + ".chunk.css";
};